module.exports = __webpack_public_path__ + "img/the-netherlands-ischemic-heart-disease-female.48fb0cf5.png";